export default "__VITE_ASSET__BF4Teq$z__"